import { createActions } from 'redux-actions'

export const {
  company: {
    getDetail: getCompanyDetail,
    getDetailSuccess: getCompanyDetailSuccess,
    getDetailFailure: getCompanyDetailFailure
  }
} = createActions({
  COMPANY: {
    GET_DETAIL: (id) => ({ id }),
    GET_DETAIL_SUCCESS: [(info) => ({ info }), (payload, meta) => meta],
    GET_DETAIL_FAILURE: [(message) => ({ message }), (payload, meta) => meta]
  }
})
